import React from 'react';
import styled from 'styled-components';
import { Flex } from 'rebass';
import { Query } from 'react-apollo';

import { GET_MEMBERSHIPS } from '../../graphql';
import { Section } from './components/Section';
import subscriptionsKit from '../../static/subscriptionsKit.png';
import subscriptionsVitamin from '../../static/subscriptionsVitamins.png';
import subscriptionsPaloma from '../../static/subscriptionsPaloma.png';
import subscriptionsPalomaScale from '../../static/Scale.png';
import PleaseWait from '../../components/PleaseWait';
import { withRouter } from 'react-router';
import { isToggleActive } from '../../components/featureToggle/toggles';

const Wrapper = styled(Flex)`
  flex: 1;
  background: white;
  border-radius: 8px 8px 8px 8px;
  flex-direction: column;
  width: 100%;
  max-width: 1200px;
  box-shadow: 0px 2.41029px 24.1029px rgba(0, 0, 0, 0.1);
  @media screen and (max-width: 480px) {
    max-width: calc(100vw - 24px);
    margin: 12px;
  }
`;

const Subscriptions = ({ history }) => {
  const hasNewPriceFeature = isToggleActive('USE_NEW_PRICING');
  return (
    <Query query={GET_MEMBERSHIPS} fetchPolicy="network-only">
      {({ loading, data, error }) => {
        if (loading) return <PleaseWait style={{ position: 'absolute', left: '50%', top: '50%' }} />;

        const membershipData = data.getMemberships.memberships.find((x) => x.subscriptionTarget === 'SUBSCRIPTION_MEMBERSHIP');
        const kitData = data.getMemberships.memberships.find((x) => x.subscriptionTarget === 'SUBSCRIPTION_KIT');
        const vitaminsData = data.getMemberships.memberships.find((x) => x.subscriptionTarget === 'SUBSCRIPTION_VITAMINS');
        const subscriptionGI = data.getMemberships.memberships.find((x) => x.subscriptionTarget === 'SUBSCRIPTION_GI');

        const membshps = ((data.getMemberships || {}).memberships || []).filter((x) => x.subscriptionTarget === 'SUBSCRIPTION_MEMBERSHIP');
        const pausedMemberships = ((data.getMemberships || {}).paused || [])//.filter((x) => x.subscriptionTarget === 'SUBSCRIPTION_MEMBERSHIP');

        const getName = (nickname) => {
          if (!nickname) return 'Hormone Rebalance Membership';
          if (nickname.indexOf('Weight Loss') > -1) {
            return 'Weight Loss Membership';
          }
          if (nickname.indexOf('Metabolic') > -1) {
            return 'Metabolic Reset Membership';
          }
          if (nickname.indexOf('Complete') > -1) {
            return 'Complete Health Boost Membership';
          }
          return 'Hormone Rebalance Membership';
        };

        const getDescription = (nickname) => {
          if (!nickname) return 'Get expert support for thyroid and menopause health to feel your best everyday.';
          if (nickname.indexOf('Weight Loss') > -1) {
            return 'Designed to help you achieve sustainable weight management. Lose up to 20% of your body weight*';
          }
          if (nickname.indexOf('Metabolic') > -1) {
            return 'Comprehensive support for thyroid, weight, and menopause health.';
          }
          if (nickname.indexOf('Complete') > -1) {
            return 'Thyroid, weight, and menopause care + a personalized health coach to support you along the way.';
          }
          return 'Get expert support for thyroid and menopause health to feel your best everyday.';
        };

        return (
          <Wrapper>
            {pausedMemberships && 
            pausedMemberships.length > 0 &&
              pausedMemberships.map((m) => {
                console.log({m})
                return (
                  <Section
                    type="membership"
                    isFirst={true}
                    imageSource={m.subscriptionNickname && m.subscriptionNickname.indexOf('Weight Loss') > -1 ? subscriptionsPalomaScale : subscriptionsPaloma}
                    title={`${getName(m.subscriptionNickname)} - Pause Plan`}
                    priceText={'$8/month'}
                    description={'Your full membership is paused. You are currently on our $8/month Pause Plan.'}
                    data={m}
                    isOnPausedMembership
                    subscribe={() => {
                      history.push('/become-member');
                    }}
                  />
                );
              })}
            {membshps &&
              membshps.length > 0 &&
              membshps.map((m) => {
                return (
                  <Section
                    type="membership"
                    isFirst={true}
                    imageSource={m.subscriptionNickname && m.subscriptionNickname.indexOf('Weight Loss') > -1 ? subscriptionsPalomaScale : subscriptionsPaloma}
                    title={getName(m.subscriptionNickname)}
                    priceText={m ? `$${m.price / 100}/${m.interval}` : '$20/month'}
                    description={getDescription(m.subscriptionNickname) || 'Exclusive perks and discounts across Paloma Health products and services'}
                    data={m}
                    subscribe={() => {
                      history.push('/become-member');
                    }}
                  />
                );
              })}
            {subscriptionGI && (
              <Section
                type="subscriptionGI"
                isFirst={!membshps || membshps.length < 1}
                imageSource={subscriptionsPaloma}
                title={'Gut Reset Membership'}
                description={'Our GUT Reset Program is a science-based approach to restoring gut balance and supporting your thyroid and hormonal health from the inside out.'}
                endsOn={subscriptionGI.nextBill.date}
                hideLearnMore
                icon={
                  <svg style={{ marginRight: '10px' }} width="78" viewBox="0 0 26 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M24.362 18.0454C23.2972 19.35 21.9678 20.2275 20.5461 20.9592C17.1202 22.7225 13.5115 23.142 9.74675 22.3596C8.98145 22.2006 8.19952 22.1166 7.42254 22.0207C6.03312 21.8487 4.75387 21.3946 3.71009 20.446C2.52224 19.3663 1.67037 18.0364 1.09452 16.5386C-0.0304666 13.6119 -0.360443 10.6218 0.445296 7.55491C0.730539 6.46871 1.28944 5.51317 1.86711 4.55881C2.72531 3.14034 3.90265 2.04156 5.21708 1.08118C6.02979 0.487466 6.99998 0.25374 7.98583 0.152942C11.8338 -0.23961 15.6118 0.11286 19.2898 1.33372C19.9566 1.55508 20.6673 1.81729 21.19 2.25981C21.958 2.9327 22.6508 3.68712 23.2563 4.50981C24.3 5.88315 24.8703 7.48646 25.2301 9.16209C25.6141 10.9518 25.9303 12.7534 25.728 14.5954C25.586 15.8843 25.0549 17.0272 24.362 18.0454Z"
                      fill="#F5E4DD"
                    />
                    <g clipPath="url(#clip0_126_3253)">
                      <path
                        d="M14.4561 12.526C15.0964 12.526 15.7104 12.2717 16.1631 11.819M14.4561 12.526C13.8158 12.526 13.2018 12.2717 12.749 11.819M14.4561 12.526V14.3366M16.1631 11.819C16.6159 11.3662 16.8702 10.7522 16.8702 10.1119M16.1631 11.819L17.4433 13.0991M16.8702 10.1119C16.8702 9.47164 16.6159 8.8576 16.1631 8.40486M16.8702 10.1119H18.6808M16.1631 8.40486C15.7104 7.95212 15.0964 7.69778 14.4561 7.69778M16.1631 8.40486L17.4433 7.12381M14.4561 7.69778C13.8158 7.69778 13.2018 7.95212 12.749 8.40486M14.4561 7.69778V5.88718M12.749 8.40486C12.2963 8.8576 12.042 9.47164 12.042 10.1119M12.749 8.40486L11.4689 7.12381M12.042 10.1119C12.042 10.7522 12.2963 11.3662 12.749 11.819M12.042 10.1119H10.2314M12.749 11.819L11.4689 13.0991M14.0543 5.88718H14.8587M17.1589 6.83944L17.7286 7.40905M18.6808 9.70926V10.5137M17.7286 12.8148L17.1589 13.3835M14.8587 14.3366H14.0543M11.7532 13.3835L11.1845 12.8148M10.2314 10.5137V9.70926M11.1845 7.40905L11.7532 6.83944"
                        stroke="#EBB6A7"
                        strokeWidth="1"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M9.39215 21.0068C9.44222 19.8919 9.68526 18.7941 10.1105 17.7622C13.7021 18.3579 19.9035 16.3577 21.7637 12.6382C24.2518 7.65778 19.9157 1.46678 14.19 2.42078C12.4751 2.71066 10.8772 3.47976 9.58086 4.63924C8.49467 3.61219 8.45032 3.22259 7.56328 1.43982M3.11679 1.43982C3.86548 3.95189 5.15891 6.26796 6.90496 8.22305C5.69094 10.7711 5.49353 13.5714 6.45014 15.422C5.51789 17.14 5.00254 19.053 4.94565 21.0068"
                        stroke="#344F7A"
                        strokeWidth="1"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_126_3253">
                        <rect width="20.8715" height="20.8715" fill="white" transform="translate(2.36282 0.787598)" />
                      </clipPath>
                    </defs>
                  </svg>
                }
                subscribe={() => {
                  history.push('/programs/gut-reset');
                }}
              />
            )}
            <Section
              type="subscription_vitamin"
              imageSource={subscriptionsVitamin}
              title="Vitamin Supplements Subscription"
              priceText={vitaminsData ? `$${vitaminsData.price / 100}/month` : 'Learn More'}
              description="Our reinvented multivitamins for hypothyroidism and hashimoto’s"
              data={vitaminsData}
              subscribe={() => {
                if (hasNewPriceFeature) {
                  history.push({
                    pathname: '/order-vitamins',
                    state: { defaultSelectSubscribe: true },
                  });
                } else {
                  window.location = 'https://www.palomahealth.com/product/thyroid-supplements';
                }
              }}
            />
            <Section
              type="subscription_kit"
              isLast={true}
              imageSource={subscriptionsKit}
              title="Kit subscriptions"
              priceText="$70/quarter"
              description="We help you stay on top of your care for you. Subscribe and save"
              data={kitData}
              subscribe={() => {
                window.location = 'https://www.palomahealth.com/kit-subscriptions';
              }}
            />
          </Wrapper>
        );
      }}
    </Query>
  );
};

export default withRouter(Subscriptions);
